<template>
    <div class="section-wrapper fullwidth">
        <!-- main content -->

        <footer class="style__FooterStyled-mhz7q3-1 efXZNd" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">  
        <div class="style__FooterTop-mhz7q3-4 iJIrpd">
                <div class="style__FooterTopWrap-mhz7q3-5 kWCkJH" dir="rtl">
                    <a class="phone" :href="'tel:' + supportnumber" dir="rtl">
                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512"
                             class="phone" style="color:#26a6c7" height="1em" width="1em"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"></path>
                        </svg>
                        {{ supportnumber }}
                    </a>

                    <ul class="style__SocialNavItem-sc-11jg1jj-0 lplSNG">
                        <li class="react-reveal" >
                            <a href="https://www.facebook.com/MarketEquityInc" target="_blank"
                               rel="noopener noreferrer">Facebook
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                     viewBox="0 0 320 512" class="socialIcons" style="color:#26a6c7"
                                     height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z">
                                    </path>
                                </svg>
                            </a>
                        </li>
                        <li class="react-reveal">
                            <a href="https://www.linkedin.com/company/market-equity-inc" target="_blank"
                               rel="noopener noreferrer">Linked In
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                     viewBox="0 0 448 512" class="socialIcons" style="color:#26a6c7"
                                     height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z">
                                    </path>
                                </svg>
                            </a>
                        </li>
                        <li class="react-reveal">
                            <a href="https://twitter.com/marketequityinc" target="_blank"
                               rel="noopener noreferrer">Twitter
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                     viewBox="0 0 512 512" class="socialIcons" style="color:#26a6c7"
                                     height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z">
                                    </path>
                                </svg>
                            </a>
                        </li>
                        <li class="react-reveal">
                            <a href="https://www.youtube.com/channel/UC9pvztCC4o0dTWuGLKVgbvQ" target="_blank"
                               rel="noopener noreferrer">Youtube
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                     viewBox="0 0 576 512" class="socialIcons" style="color:#26a6c7"
                                     height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z">
                                    </path>
                                </svg>
                            </a>
                        </li>
                        <li class="react-reveal">
                            <a href="https://www.pinterest.com/mequityinc/" target="_blank"
                               rel="noopener noreferrer">Pinterest
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                     viewBox="0 0 384 512" class="socialIcons" style="color:#26a6c7"
                                     height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z">
                                    </path>
                                </svg>
                            </a>
                        </li>
                        <li class="react-reveal">
                            <a href="https://www.instagram.com/marketequityinc/" target="_blank"
                               rel="noopener noreferrer">Instagram
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                     viewBox="0 0 448 512" class="socialIcons" style="color:#26a6c7"
                                     height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z">
                                    </path>
                                </svg>
                            </a>
                        </li>
                        <li class="react-reveal">
                            <a href="https://t.me/joinchat/AAAAAFknbhn1QjrGw4tDNQ" target="_blank"
                               rel="noopener noreferrer">Telegram
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0"
                                     viewBox="0 0 496 512" class="socialIcons" style="color:#26a6c7"
                                     height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z">
                                    </path>
                                </svg>
                            </a>
                        </li>



                    </ul>

                    <a :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'" class="mail" :href="'mailto:' + supportemail">{{ this.supportemail }}</a>
                </div>
            </div>
            <div class="style__FooterWrap-mhz7q3-0 ekpszL" :style="$i18n.locale=='العربية'?'align:right':'align:left'">
                <div class="react-reveal" style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;font-family: 'Cairo', sans-serif!important;">
                    <div class="style__FooterNavWrap-mhz7q3-2 ignezi">
                        <div v-for="mainmenu  in mainmenus" :key="mainmenu.id" class="style__DropDownItemStyled-sc-1ndrbr9-0 ejBNec" :style="$i18n.locale == 'العربية' ? 'font-family:GE SS Two Medium!important;' :'Comfortaa!important;'">
                            <h3 :style="$i18n.locale=='العربية'?'color:#ffffff;text-transform:capitalize;font-weight:bold;text-align:right;font-family: Cairo,sans-serif !important;':'color:#ffffff;text-transform:capitalize;font-weight:bold;text-align:left;font-family: Comfortaa!important;'"  >
                                {{ $i18n.locale=='en'?mainmenu.en_title:$i18n.locale=='العربية'?mainmenu.ar_title:$i18n.locale=='中文'?mainmenu.ch_title:$i18n.locale=='Русский'?mainmenu.ru_title:mainmenu.fr_title }}</h3>
                            <ul :style="$i18n.locale=='العربية'?'text-align:right':'text-align:left'" v-for="submenu  in submenus"  :key="submenu.id" class="style__DropDownList-sc-1ndrbr9-1 eLdVbJ">
                                <li v-if="submenu.parent_id==mainmenu.id" class="style__DropDownLinks-sc-1ndrbr9-2 fctzjX">
 <a :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'" :class="pathname === submenu.name ? 'active' : ''" :href="'../../'+lanflag+'/'+submenu.name">{{ $i18n.locale=='en'?submenu.en_title:$i18n.locale=='العربية'?submenu.ar_title:$i18n.locale=='中文'?submenu.ch_title:$i18n.locale=='Русский'?submenu.ru_title:submenu.fr_title }}</a>
                                </li>

                            </ul>
                        </div>

                    </div>
                </div>
               
                
                <div class="react-reveal"  v-html="$i18n.locale=='en'?riskwarningen:$i18n.locale=='العربية'?riskwarningar:$i18n.locale=='中文'?riskwarningch:$i18n.locale=='Русский'?riskwarningru:riskwarningfr">
                    <p :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">
                        <b></b>

                        {{ $i18n.locale=='en'?riskwarningen:$i18n.locale=='العربية'?riskwarningar:$i18n.locale=='中文'?riskwarningch:$i18n.locale=='Русский'?riskwarningru:riskwarningfr}}</p>
                    <p>&nbsp;</p>
                </div>
                <div class="react-reveal" style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                    <ul :class="$i18n.locale=='en'?'style__PrivacyLinksStyled-sc-1abpsjn-0 djIugD ':'style__PrivacyLinksStyled-sc-1abpsjn-0 dyaizA'" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">
                        <li class="style__NavItemStyled-sc-1qsj0rt-0 tUscN">

<a :style="$i18n.locale == 'العربية' ? 'font-family: Cairo, sans-serif !important;' :'font-family:Roboto,sans-serif;'" :href="$i18n.locale=='en'?'../en/risk-warning':$i18n.locale=='العربية'?'../ar/risk-warning':$i18n.locale=='中文'?'../ch/risk-warning':'../fr/risk-warning'">

                                {{ $i18n.locale=='en'?'RISK WARNING':$i18n.locale=='العربية'?'تحذير المخاطر':$i18n.locale=='中文'?'RISK WARNING':'Avertissement de risque' }}</a>
                        </li>
                        <li class="style__NavItemStyled-sc-1qsj0rt-0 tUscN">

                            <a :href="$i18n.locale=='en'?'../en/privacy-and-security-policy':$i18n.locale=='العربية'?'../ar/privacy-and-security-policy':$i18n.locale=='中文'?'../ch/privacy-and-security-policy':'../fr/privacy-and-security-policy'">


{{ $i18n.locale=='en'?'Privacy and Security Policy':$i18n.locale=='العربية'?'سياسة الخصوصية و الأمن':$i18n.locale=='中文'?'Privacy and Security Policy':$i18n.locale=='Русский'?'Политика конфиденциальности и безопасности':'Politique de confidentialité et de sécurité' }}</a>

                        </li>
                        <li class="style__NavItemStyled-sc-1qsj0rt-0 tUscN">

                            <a :href="$i18n.locale=='en'?'../en/disclaimer':$i18n.locale=='العربية'?'../ar/disclaimer':$i18n.locale=='中文'?'../ch/disclaimer':'../fr/disclaimer'">


{{ $i18n.locale=='en'?'DISCLAIMER':$i18n.locale=='العربية'?'إخلاء المسؤولية':$i18n.locale=='中文'?'DISCLAIMER':$i18n.locale=='Русский'?'Отказ от ответственности':'DISCLAIMER' }}</a>



                        </li>
                        <li class="style__NavItemStyled-sc-1qsj0rt-0 tUscN">

                            <a :href="$i18n.locale=='en'?'../en/terms-and-conditions':$i18n.locale=='العربية'?'../ar/terms-and-conditions':$i18n.locale=='中文'?'../ch/terms-and-conditions':'../fr/terms-and-conditions'">


                                {{ $i18n.locale=='en'?'TERMS AND CONDITIONS':$i18n.locale=='العربية'?'لشروط و الأحكام':$i18n.locale=='中文'?'TERMS AND CONDITIONS':$i18n.locale=='Русский'?'Условия и положения':'Termes et conditions ' }}</a>

                        </li>
                        <li class="style__NavItemStyled-sc-1qsj0rt-0 tUscN">

                            <a :href="$i18n.locale=='en'?'../en/orders-execution-policy':$i18n.locale=='العربية'?'../ar/orders-execution-policy':$i18n.locale=='中文'?'../ch/orders-execution-policy':'../fr/orders-execution-policy'">


                                {{ $i18n.locale=='en'?'ORDERS EXECUTION POLICY':$i18n.locale=='العربية'?'سياسة وتنفيذ الأوامر':$i18n.locale=='中文'?'ORDERS EXECUTION POLICY':$i18n.locale=='Русский'?'Политика исполнения ордеров':"la politique d'exécution des ordres" }}</a>
                        </li>
                        <li class="style__NavItemStyled-sc-1qsj0rt-0 tUscN">

                            <a :href="$i18n.locale=='en'?'../en/aml':$i18n.locale=='العربية'?'../ar/aml':$i18n.locale=='中文'?'../ch/aml':'../fr/aml'">


                                {{ $i18n.locale=='en'?'AML':$i18n.locale=='العربية'?'مكافحة غسيل الأموال':$i18n.locale=='中文'?'AML':$i18n.locale=='Русский'?'AML':"AML" }}</a>


                        </li>
                        <li class="style__NavItemStyled-sc-1qsj0rt-0 tUscN">

                            <a :href="$i18n.locale=='en'?'../en/trading-conditions':$i18n.locale=='العربية'?'../ar/trading-conditions':$i18n.locale=='中文'?'../ch/trading-conditions':'../fr/trading-conditions'">


  {{ $i18n.locale=='en'?'Trading Conditions':$i18n.locale=='العربية'?'شروط التداول':$i18n.locale=='中文'?'Trading Conditions':$i18n.locale=='Русский'?'Условия совершения операций':"Les conditions du trading" }}</a>

                        </li>
                        
                        <li class="style__NavItemStyled-sc-1qsj0rt-0 tUscN">

                            <a target="_blank" href="https://frontend.marketequityinc.com/public/forms/COMPLAINT%20REGISTRATION%20FORM.docx">


{{ $i18n.locale=='en'?'Complaint Registration Form':$i18n.locale=='العربية'?'شروط إستمارة تسجيل شكوى ':$i18n.locale=='中文'?'Complaint Registration Form':$i18n.locale=='Русский'?'Complaint Registration Form':"formulaire d'enregistrement de plainte" }}</a>

                        </li>
                    </ul>
                </div>
                <div class="react-reveal">
                    <div class="style__PaymentLogos-sc-1nj6zbk-0 elJTtb">
                        <ul>
                            <li>
                                <a href="https://portal.marketequityinc.com/login">
                                    <div class=" gatsby-image-wrapper"
                                         style="position:relative;overflow:hidden;display:inline-block;width:88px;height:36px">
                                        <img aria-hidden="true"
                                             src="../../public/paymenticons/visa1.png"
                                             alt=""
                                             style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>
                                        <noscript>
                                            <picture>

                                                <img loading="lazy" width="88" height="36"
                                                     src="../../public/paymenticons/visa1.png"
                                                     alt=""
                                                     style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </noscript>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://portal.marketequityinc.com/login">
                                    <div class=" gatsby-image-wrapper"
                                         style="position:relative;overflow:hidden;display:inline-block;width:88px;height:36px">
                                        <img aria-hidden="true"
                                             src="../../public/paymenticons/mastercard.png"                                                 alt=""
                                             style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>
                                        <noscript>
                                            <picture>

                                                <img loading="lazy" width="88" height="36"
                                                     src="../../public/paymenticons/mastercard.png"                                                 alt=""
                                                     alt=""
                                                     style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </noscript>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://portal.marketequityinc.com/login">
                                    <div class=" gatsby-image-wrapper"
                                         style="position:relative;overflow:hidden;display:inline-block;width:88px;height:36px">
                                        <img aria-hidden="true"
                                             src="../../public/paymenticons/knet.png"
                                             alt=""
                                             style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>
                                        <noscript>
                                            <picture>

                                                <img loading="lazy" width="88" height="36"
                                                     src="../../public/paymenticons/knet.png"
                                                     alt=""
                                                     style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </noscript>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://portal.marketequityinc.com/login">
                                    <div class=" gatsby-image-wrapper"
                                         style="position:relative;overflow:hidden;display:inline-block;width:88px;height:36px">
                                        <img aria-hidden="true"
                                             src="../../public/paymenticons/sticpay.png"
                                             alt=""
                                             style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>
                                        <noscript>
                                            <picture>

                                                <img loading="lazy" width="88" height="36"
                                                     src="../../public/paymenticons/sticpay.png"

                                                     alt=""
                                                     style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </noscript>
                                    </div>
                                </a>
                            </li>
                            
<!--            <li>-->
<!--                <a href="https://portal.marketequityinc.com/login">-->
<!--                    <div class=" gatsby-image-wrapper"-->
<!--                         style="position:relative;overflow:hidden;display:inline-block;width:88px;height:36px">-->
<!--                        <img aria-hidden="true"-->
<!--                             src="../../public/paymenticons/cashu.png"-->
<!--                             alt=""-->
<!--                             style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>-->
<!--                        <noscript>-->
<!--                            <picture>-->

<!--                                <img loading="lazy" width="88" height="36"-->
<!--                                     src="../../public/paymenticons/cashu.png"-->
<!--                                     alt=""-->
<!--                                     style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>-->
<!--                            </picture>-->
<!--                        </noscript>-->
<!--                    </div>-->
<!--                </a>-->
<!--            </li>-->                                                        <li>
                                <a href="https://portal.marketequityinc.com/login">
                                    <div class=" gatsby-image-wrapper"
                                         style="position:relative;overflow:hidden;display:inline-block;width:88px;height:36px">
                                        <img aria-hidden="true"
                                             src="../../public/paymenticons/neteller.png"
                                             style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>
                                        <noscript>
                                            <picture>

                                                <img loading="lazy" width="88" height="36"
                                                     src="../../public/paymenticons/neteller.png"
                                                     alt=""
                                                     style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </noscript>
                                    </div>
                                </a>
                            </li>
                              <li>
                                <a href="https://portal.marketequityinc.com/login">
                                    <div class=" gatsby-image-wrapper"
                                         style="position:relative;overflow:hidden;display:inline-block;width:88px;height:36px">
                                        <img aria-hidden="true"
                                             src="../../public/paymenticons/skrill.png"
                                             style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>
                                        <noscript>
                                            <picture>

                                                <img loading="lazy" width="88" height="36"
                                                     src="../../public/paymenticons/skrill.png"
                                                     style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </noscript>
                                    </div>
                                </a>
                            </li>
                             <li>
                                <a href="#">
                                    <div class=" gatsby-image-wrapper"
                                         style="position:relative;overflow:hidden;display:inline-block;width:88px;height:36px">
                                        <img aria-hidden="true"
                                             src="../../public/paymenticons/fasapay.png"
                                             style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>
                                        <noscript>
                                            <picture>

                                                <img loading="lazy" width="88" height="36"
                                                     src="../../public/paymenticons/fasapay.png"
                                                     style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </noscript>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
                <div class="react-reveal">
                    <p class="style__Copyright-mhz7q3-3 dEguAM"> &copy; {{ $i18n.locale=='en'?copyrighten:$i18n.locale=='العربية'?copyrightar:$i18n.locale=='中文'?copyrightch:copyrightfr}}</p>
                </div>

            </div>
        </footer>


        <!-- aside content -->
    </div>

</template>
<script>

export default {
    name: 'footer',
    data() {
        return {

            riskwarningen: null,
            riskwarningar: null,
            riskwarningfr: null,
            riskwarningch: null,
            riskwarningru: null,

            supportnumber: null,
            supportemail: null,
            copyrighten: null,
            copyrightar: null,
            copyrightch: null,
            copyrightfr: null,
            copyrightru: null,

            footerbg:null,
            locale: 'en',
            mainmenus:'',
            submenus:'',
            lanflag:'en',
            pathname:'',

        }
    },

    created() {
        // document.title = "Look Ma!";
        this.lanflag=this.$i18n.locale;
        if (this.$i18n.locale == 'العربية') {
            this.lanflag='ar';
        }
           if (this.$i18n.locale=='中文') {
            this.lanflag='ch';
           
        }
        
          if (this.$i18n.locale=='Français') {
            this.lanflag='fr';
        }
          if (this.$i18n.locale=='Русский') {
            this.lanflag='ru';
        }
    },
    beforeMount() {
        this.loaddata();
        this.loadmenus();
        var pathvalues=(this.$route.path).split("/");

        this.pathname=pathvalues[2];
        this.lanflag=this.$i18n.locale;
        if (this.$i18n.locale == 'العربية') {
            this.lanflag='ar';
        }
         if (this.$i18n.locale=='中文') {
            this.lanflag='ch';
            
        }
        
          if (this.$i18n.locale=='Français') {
            this.lanflag='fr';
        }
        if (this.$i18n.locale=='Русский') {
            this.lanflag='ru';
        }

    },

    methods: {
        loadchat() {


        },

        loaddata() {

            this.$axios.get("loadheaderdata",
            )
                .then(res => {
                    if (res) {
                        this.sitesettings=res.data.sitesettings[0];
                        this.logo = res.data.sitesettings[0].logo;
                        this.sitetitleen = res.data.sitesettings[0].sitetitleen;
                        this.sitetitlear = res.data.sitesettings[0].sitetitlear;
                        this.sitetitlefr = res.data.sitesettings[0].sitetitlefr;
                        this.sitetitlech = res.data.sitesettings[0].sitetitlech;
                        this.riskwarningen = res.data.sitesettings[0].riskwarningen;
                        this.riskwarningar = res.data.sitesettings[0].riskwarningar;
                        this.riskwarningch = res.data.sitesettings[0].riskwarningch;
                        this.riskwarningfr = res.data.sitesettings[0].riskwarningfr;
                        this.riskwarningru = res.data.sitesettings[0].riskwarningru;
                        this.supportnumber = res.data.sitesettings[0].supportnumber;
                        this.supportemail = res.data.sitesettings[0].supportemail;
                        this.copyrighten = res.data.sitesettings[0].copyrighten;
                        this.copyrightar = res.data.sitesettings[0].copyrightar;
                        this.copyrightch = res.data.sitesettings[0].copyrightch;
                        this.copyrightfr = res.data.sitesettings[0].copyrightfr;
                        this.footerbg = res.data.sitesettings[0].footerimage;
                    }
                });
        },
        langchange(lang) {

            this.$i18n.locale = lang;
            if (lang == 'en') {
                document.title = this.sitetitleen;
                document.dir = "ltr";


            }
            if (lang == 'العربية') {
                document.title = this.sitetitlear;
                document.dir = "rtl";
            }
            if (lang == '中文') {
                document.dir = "ltr";
                document.title = this.sitetitlefr;
            }
            if (lang == 'Français') {
                document.dir = "ltr";
                document.title = this.sitetitleen;
            }
             if (lang == 'Русский') {
                document.dir = "ltr";
                document.title = this.sitetitleen;
            }
        },
        loadmenus() {

            this.$axios.get("loadmenus",
            )
                .then(res => {
                    if (res) {

                        this.mainmenus = res.data.mainmenus;
                        this.submenus = res.data.submenus;


                    }
                });
        },

    }

}

</script>
<style>
.ignezi > div a:hover::before, .ignezi > div a.active::before {
    width: 11px!important;
    height: 14px!important;

    top: 5px!important;
    left: -25px!important;

}

.ignezi > div a:hover::after, .ignezi > div a.active::after {

    width: 11px!important;
    height: 2px!important;
    border-bottom: 2px solid #fff;
    top: 12px!important;
    left: -27px!important;

}
.ignezi > div h3{
    text-transform:none!important;
    padding-bottom:1%!important;
}
.ignezi > div ul {
}
.lplSNG li a {
    display: block;
    width: 38px!important;
    height: 39px!important;
    position: relative;
}
.dyaizA.right::before {
    background: rgba(0, 0, 0, 0) url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAMCAYAAACa7GYMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkQzNzA0RDYyQTdBRjExRTlBMDM4QzFFRjlCMTgxN0FGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkQzNzA0RDYzQTdBRjExRTlBMDM4QzFFRjlCMTgxN0FGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDM3MDRENjBBN0FGMTFFOUEwMzhDMUVGOUIxODE3QUYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDM3MDRENjFBN0FGMTFFOUEwMzhDMUVGOUIxODE3QUYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4L5Kw5AAABhklEQVR42qzUzSuEQRzA8WcXoU3e2oRtDxa5UFKc3FZOLg5ykRNOOIgcHJTyFyinLXJVcnDwkiLZg60NLZs2DpJys1i72B3f0Tw1bbueZ+VXn3re5jczz8z8HEIII08UoR1tyKhnTlziWt1nDPtRiSRS5oPiHB+VwYMJdKAX5erdK04QQgTbagApi479WMIVtnCIhCFnrqnAGILCOiJYwQCcWXl0fpxq7e6xim79oyrM4U4UFmEswAePytWoruVEonnaRR1qzasxjhm4jcLjE7c4xzGa0YcmbcmyI2jOeAoP4n8iiQ8bf2tYdj6NmM2k6X8Y3BMm5aTlbu+H75dfGsMjNuDFIOpQ+4flkacigHXEzd24n2OEcayhC25tY3rVRjpCooAZP2NZnaifXGbCHgTwrnW8iJY8x6cU9ZjHAb4sOg5hFi49j7nbZeVyYQSj2MEmohZVrAQNGEKrWpIarfpdYA9n2MWL3tiRo7zKMvimGtstn051vDohtOp5g7C6T2c3+hZgAOo854jtSJ0HAAAAAElFTkSuQmCC") no-repeat scroll center center / contain;
    content: " ";
    position: absolute;
    width: 31px;
    height: 12px;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
}
.dyaizA.left::before {
    background: rgba(0, 0, 0, 0) url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAMCAYAAACa7GYMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkQzNzA0RDYyQTdBRjExRTlBMDM4QzFFRjlCMTgxN0FGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkQzNzA0RDYzQTdBRjExRTlBMDM4QzFFRjlCMTgxN0FGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDM3MDRENjBBN0FGMTFFOUEwMzhDMUVGOUIxODE3QUYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDM3MDRENjFBN0FGMTFFOUEwMzhDMUVGOUIxODE3QUYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4L5Kw5AAABhklEQVR42qzUzSuEQRzA8WcXoU3e2oRtDxa5UFKc3FZOLg5ykRNOOIgcHJTyFyinLXJVcnDwkiLZg60NLZs2DpJys1i72B3f0Tw1bbueZ+VXn3re5jczz8z8HEIII08UoR1tyKhnTlziWt1nDPtRiSRS5oPiHB+VwYMJdKAX5erdK04QQgTbagApi479WMIVtnCIhCFnrqnAGILCOiJYwQCcWXl0fpxq7e6xim79oyrM4U4UFmEswAePytWoruVEonnaRR1qzasxjhm4jcLjE7c4xzGa0YcmbcmyI2jOeAoP4n8iiQ8bf2tYdj6NmM2k6X8Y3BMm5aTlbu+H75dfGsMjNuDFIOpQ+4flkacigHXEzd24n2OEcayhC25tY3rVRjpCooAZP2NZnaifXGbCHgTwrnW8iJY8x6cU9ZjHAb4sOg5hFi49j7nbZeVyYQSj2MEmohZVrAQNGEKrWpIarfpdYA9n2MWL3tiRo7zKMvimGtstn051vDohtOp5g7C6T2c3+hZgAOo854jtSJ0HAAAAAElFTkSuQmCC") no-repeat scroll center center / contain;
    content: " ";
    position: absolute;
    width: 31px;
    height: 12px;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
}
.efXZNd {
    background-color: transparent!important;
}
.efXZNd{
   background-color:transparent!important; 
padding-bottom: 80px!important;
}
.efXZNd::before {
    background: url(https://devbackup.marketequityinc.com/public/public/142/2021062216112020201224121330footer_marketequity.jpg)!important;opacity: 1!important;

}

  .iJIrpd {
    background: #1a859d!important;
  }
  .iJIrpd::after {
          background: url(https://devbackup.marketequityinc.com/public/public/143/20210622221055footerarrow.png)!important;
  }
.elJTtb li img {
  
    filter: none!important;
  
}
</style>


